// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/mobile.scss
// module id = 233
// module chunks = 0